import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { Mask } from 'antd-mobile';
import CommonUtil from '../../utils/CommonUtil';

const LoginHelpDetail = props => {
    const navigate = useNavigate()
    const [searchParams] = useSearchParams()
    const { t } = useTranslation()

    const [concatDlgVisible, setConcatDlgVisible] = useState(false)
    const [wechatDlgVisible, setWechatDlgVisible] = useState(false)

    const handleOnCancat = () => {
        setConcatDlgVisible(true)
    }

    const handleOnPhoneClick = () => {
        window.ReactNativeWebView.postMessage('400-069-0588')
    }

    const handleOnWechatClick = () => {
        setConcatDlgVisible(false)
        setWechatDlgVisible(true)
    }

    const renderContent = () => {
        const type = searchParams.get('type')
        let title = ''
        let message = ''
        if (type === 'vercode') {
            title = t('login_item_no_vercode')
            message = t('login_no_vercode_content')
        } else if (type === 'login_failed') {
            title = t('login_item_login_failed')
            message = t('login_failed_content')
        } else {
            title = t('login_item_forget_pwd')
            message = t('login_forget_pwd_content')
        }
        return <div className='navbar'>
            <div style={styles.title}>{title}</div>
            <div className='preLine'>{message}</div>
        </div>
    }
    return <div className='App'>
        {renderContent()}
        <>
            <Mask visible={concatDlgVisible} onMaskClick={() => setConcatDlgVisible(false)}
                color='#00000066'>
                <div className='cancatContent'>
                    <div style={styles.dlgTitle}>
                        <span style={{ fontSize: 15, color: '#000000', fontWeight: '500' }}>{t('cancat')}</span>
                        <div style={{ position: 'absolute', top: 19, right: 15, width: 32, height: 32 }}
                            onClick={() => setConcatDlgVisible(false)}>
                            <img src={`${CommonUtil.getSourceDomain()}modal_close.png`} alt='' style={{ width: 32, height: 32 }} />
                        </div>
                    </div>
                    <span style={{ height: 6 }} />
                    <div className='cancatContentItem' onClick={handleOnPhoneClick}>
                        <img src={`${CommonUtil.getSourceDomain()}help_phone.png`} alt='' style={{ width: 40, height: 40, marginLeft: 20 }} />
                        <div style={{ display: 'flex', marginLeft: 15, flexDirection: 'column' }}>
                            <span style={{ color: '#917BBB', fontSize: 12, fontWeight: '500' }}>{t('cancat_phone')}</span>
                            <span style={{ color: '#000000', fontSize: 14, fontWeight: '500', marginTop: 5 }}>{t('phone_num')}</span>
                            <span style={{ color: '#00000080', fontSize: 12, marginTop: 2 }}>{t('work_time')}</span>
                        </div>
                    </div>
                    <span style={{ height: 14 }} />
                    <div className='cancatContentItem' onClick={handleOnWechatClick}>
                        <img src={`${CommonUtil.getSourceDomain()}help_wechat.png`} alt='' style={{ width: 40, height: 40, marginLeft: 20 }} />
                        <div style={{ display: 'flex', marginLeft: 15, flexDirection: 'column' }}>
                            <span style={{ color: '#917BBB', fontSize: 12, fontWeight: '500' }}>{t('wechat')}</span>
                            <span style={{ color: '#000000', fontSize: 14, fontWeight: '500', marginTop: 5 }}>{t('wechat_account')}</span>
                            <span style={{ color: '#00000080', fontSize: 12, marginTop: 2 }}>{t('work_time1')}</span>
                        </div>
                    </div>
                </div>
            </Mask>
            <div className='cancat' onClick={handleOnCancat}>
                <span style={styles.cancat}>{t('cancat')}</span>
            </div>
        </>

        <>
            <Mask visible={wechatDlgVisible} onMaskClick={() => setWechatDlgVisible(false)}
                color='#00000066'>
                <div className='wechatContent'>
                    <img src={`${CommonUtil.getSourceDomain()}wechat_qr_image.png`} alt='' style={{ width: 130, height: 130 }} />
                    <div style={{ fontSize: 14, color: '#373150', marginTop: 5 }}>{t('wechat') + ': ' + t('wechat_account')}</div>
                    <div style={{ height: 1, width: '100%', background: '#E5E5E5', marginTop: 28 }} />
                    <div style={{ fontSize: 16, color: '#7F56FF', fontWeight: '500', marginTop: 15 }}
                        onClick={() => setWechatDlgVisible(false)}>{t('btn_sure')}</div>
                </div>
            </Mask>
            <div className='cancat' onClick={handleOnCancat}>
                <span style={styles.cancat}>{t('cancat')}</span>
            </div>
        </>
    </div>
}

const styles = {
    title: {
        fontSize: 16, color: '#000000', fontWeight: '500', marginLeft: 25, marginTop: 10
    },
    itemText: {
        marginLeft: 15,
        color: '#000000CC',
        fontSize: 14,
        fontWeight: '500'
    },
    itemIcon: {
        width: 24,
        height: 24,
        marginRight: 15
    },
    cancat: {
        fontSize: 15,
        color: '#4C4C4CCC',
        fontWeight: '500'
    },
    dlgTitle: {
        display: 'flex', flexDirection: 'row', alignItems: 'center', justifyContent: 'center', width: '100%', height: 50, marginTop: 10
    }
}

export default LoginHelpDetail